/**
 * Содержание курса. Файл сгенерирован: правки вносим в course/guitar_30days.json
 * и выполняем npm run course, иначе копии разъедутся.
 */
export const COURSE = {
    "meta": {
        "title": "Гитара за 30 дней — курс для начинающего 12 лет",
        "instrument": "акустическая гитара (стальные или нейлоновые струны)",
        "level": "с нуля",
        "schedule": "5 занятий в неделю по 15–20 минут, 2 дня — отдых/свободная игра",
        "total_days": 30,
        "lessons": 20,
        "version": 1,
        "gear": [
            "Гитара по росту: для 12 лет обычно размер 3/4 или полноразмерная 4/4, если рука дотягивается до 1 лада без напряжения",
            "Тюнер: бесплатное приложение на телефон (GuitarTuna, Pano Tuner) или прищепка-тюнер",
            "Медиатор средней жёсткости (0.6–0.8 мм) — пригодится со 2-й недели",
            "Подставка под ногу или скамеечка (можно заменить толстой книгой)",
            "Каподастр не нужен — в этом курсе не используется"
        ],
        "rules": [
            "Лучше 15 минут каждый день, чем час раз в неделю",
            "Короткие ногти на левой руке — иначе струна не прижмётся",
            "Кончики пальцев поначалу побаливают — это нормально, кожа грубеет за 2–3 недели; если больно по-настоящему, занятие на сегодня заканчиваем",
            "Каждое занятие начинаем с настройки гитары — 1 минута",
            "Всегда заканчиваем на том, что уже получается: последнее впечатление должно быть «я умею»"
        ]
    },
    "chords": {
        "Em": {
            "diagram": "e|--0--\nB|--0--\nG|--0--\nD|--2--  2 палец\nA|--2--  3 палец\nE|--0--",
            "hint": "Самый лёгкий аккорд. Играются все 6 струн."
        },
        "Am": {
            "diagram": "e|--0--\nB|--1--  1 палец\nG|--2--  3 палец\nD|--2--  2 палец\nA|--0--\nE|--x--",
            "hint": "6-ю струну не задеваем. Форма похожа на Em, только сдвинута на струну вниз + 1 палец."
        },
        "Dm": {
            "diagram": "e|--1--  1 палец\nB|--3--  3 палец\nG|--2--  2 палец\nD|--0--\nA|--x--\nE|--x--",
            "hint": "Играем только 4 тонкие струны."
        },
        "C": {
            "diagram": "e|--0--\nB|--1--  1 палец\nG|--0--\nD|--2--  2 палец\nA|--3--  3 палец\nE|--x--",
            "hint": "Упрощённый вариант (первые 3 струны + бас на A): e0 B1 G0 — можно начать с него."
        },
        "G": {
            "diagram": "e|--3--  3 палец\nB|--0--\nG|--0--\nD|--0--\nA|--2--  1 палец\nE|--3--  2 палец",
            "hint": "Есть облегчённый вариант в 2 пальца: E6 3-й лад + e1 3-й лад, остальные открытые."
        },
        "D": {
            "diagram": "e|--2--  2 палец\nB|--3--  3 палец\nG|--2--  1 палец\nD|--0--\nA|--x--\nE|--x--",
            "hint": "Пальцы образуют треугольник. Играем 4 тонкие струны."
        },
        "Dsus2": {
            "diagram": "e|--0--\nB|--3--  3 палец\nG|--2--  1 палец\nD|--0--\nA|--x--\nE|--x--",
            "hint": "Облегчённая замена D на первое время, звучит красиво и почти как D."
        },
        "E7": {
            "diagram": "e|--0--\nB|--0--\nG|--1--  1 палец\nD|--0--\nA|--2--  2 палец\nE|--0--",
            "hint": "Бонусный аккорд: Em с одним добавленным пальцем, даёт «блюзовый» цвет."
        }
    },
    "tabs": {
        "spider": {
            "title": "Упражнение «паучок» (хроматика 1-2-3-4)",
            "tab": "e|-------------------1-2-3-4-|\nB|-----------1-2-3-4---------|\nG|---------------------------|\nD|---------------------------|\nA|-----1-2-3-4---------------|\nE|-1-2-3-4-------------------|",
            "how": "Каждый палец — свой лад: 1 палец на 1 лад, 2 на 2, 3 на 3, 4 на 4. Играем медленно и ровно, поднимаем пальцы по одному. Потом тем же путём обратно."
        },
        "ode_to_joy": {
            "title": "Бетховен — «Ода к радости» (мелодия, общественное достояние)",
            "tab": "e|-0--0--1--3--|-3--1--0-----|-----------0-|-0-----------|\nB|-------------|----------3--|-1--1--3-----|---3--3------|",
            "how": "Ноты только на двух тонких струнах. Играем большим пальцем или медиатором, ровно, считая 1-2-3-4."
        },
        "first_riff": {
            "title": "Рок-рифф для начинающего (упражнение курса)",
            "tab": "E|-0--0--3--0--|-0--0--5--3--|-0--0--3--0--|-0--0--0--0--|",
            "how": "Играем только на 6-й (самой толстой) струне медиатором, ударами вниз. Держим ровный темп 70–80 ударов в минуту. Звучит «как в рок-песне» — отсюда рождается интерес."
        },
        "melody_line": {
            "title": "Мелодия по одной струне (разминка левой руки)",
            "tab": "e|-0--1--3--5--3--1--0--|",
            "how": "1-й струна, пальцы 1-2-4. Следим, чтобы палец стоял вплотную к ладовому порожку — тогда звук чистый, без дребезга."
        }
    },
    "progressions": {
        "four_chords_pop": {
            "name": "«Четыре аккорда» — на них построены сотни популярных песен",
            "chords": [
                "G",
                "D",
                "Em",
                "C"
            ],
            "count": "по 4 счёта на аккорд"
        },
        "minor_pop": {
            "name": "Минорная связка — русский рок и грустные хиты",
            "chords": [
                "Am",
                "C",
                "D",
                "Em"
            ],
            "count": "по 4 счёта на аккорд"
        },
        "starter": {
            "name": "Первая связка новичка",
            "chords": [
                "Em",
                "Am"
            ],
            "count": "по 4 счёта на аккорд"
        }
    },
    "strumming": {
        "downs": "Бой «вниз»: удар вниз на каждый счёт — 1, 2, 3, 4. Кисть двигается, локоть спокоен.",
        "eight": "Бой «восьмёрка»: рука качается непрерывно вниз-вверх на все восемь долей — ↓↑↓↑↓↑↓↑, считаем «раз-и-два-и-три-и-четыре-и».",
        "arpeggio": "Перебор «четвёрка»: бас (6/5/4 струна) — 3 — 2 — 1. Большой палец играет бас, остальные — свои струны.",
        "universal": "Универсальный бой: ↓ ↓↑ ↑↓↑ — рука качается так же непрерывно, но по части движений мимо струн. Это следующий шаг после «восьмёрки»."
    },
    "days": [
        {
            "day": 1,
            "week": 1,
            "type": "lesson",
            "title": "Знакомство с гитарой",
            "goal": "Правильно сесть, назвать части гитары, настроить её и извлечь чистый звук",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Настройка",
                    "min": 4,
                    "text": "Ставим приложение-тюнер. Струны сверху вниз (от толстой к тонкой): E A D G B e — «Ешь Ананасы Другие Груши Бери Ещё». Настраиваем все 6, крутим колок очень медленно."
                },
                {
                    "name": "Посадка",
                    "min": 5,
                    "text": "Садимся на край стула, спина прямая. Гитара лежит на правом бедре (или на левом, если под ногу подставлена книга). Гриф чуть вверх. Правая рука свободно свисает через корпус, левая не держит гриф, а только прижимает струны — гитара не должна падать, если убрать левую руку."
                },
                {
                    "name": "Первый звук",
                    "min": 8,
                    "text": "Большим пальцем правой руки играем по очереди все 6 открытых струн сверху вниз, считая 1-2-3-4-5-6. Потом обратно. Задача: чтобы каждая струна звучала чисто и одинаково громко. Повторяем 10 раз."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Играем все струны сверху вниз одним движением — это «аккорд Em без пальцев». Слушаем, как долго тянется звук."
                }
            ],
            "new": "Названия струн, посадка, настройка",
            "check": "Ребёнок может сам назвать струны и настроить гитару по тюнеру",
            "parent": "Настроить гитару в первый раз лучше вместе — дальше это ежедневный ритуал на 1 минуту.",
            "fun": "Записать на телефон первое видео «день 1» — через месяц будет что сравнить."
        },
        {
            "day": 2,
            "week": 1,
            "type": "lesson",
            "title": "Правая рука: перебор",
            "goal": "Научиться играть перебором по открытым струнам ровно, под счёт",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Настройка",
                    "min": 2,
                    "text": "Настраиваем гитару сами."
                },
                {
                    "name": "Пальцы",
                    "min": 5,
                    "text": "У каждого пальца правой руки своя струна: большой — басы (6, 5, 4), указательный — 3-я, средний — 2-я, безымянный — 1-я. Пробуем щипок каждым пальцем отдельно, 10 раз."
                },
                {
                    "name": "Перебор «четвёрка»",
                    "min": 10,
                    "text": "Играем: 6 струна — 3 — 2 — 1, счёт 1-2-3-4. Повторяем 20 раз без остановок. Потом то же с басом на 5-й струне."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Играем перебор и одновременно считаем вслух — ровность важнее скорости."
                }
            ],
            "new": "Перебор p-i-m-a, распределение пальцев",
            "check": "20 повторов перебора без сбоя ритма",
            "parent": "Считайте вслух вместе — это заменяет метроном и делает занятие игрой.",
            "fun": "Включить любимую медленную песню и играть перебор под неё — уже похоже на музыку."
        },
        {
            "day": 3,
            "week": 1,
            "type": "lesson",
            "title": "Левая рука: первые ноты",
            "goal": "Прижимать струну чисто, без дребезга",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Настройка",
                    "min": 2,
                    "text": "Настраиваем гитару."
                },
                {
                    "name": "Как прижимать",
                    "min": 5,
                    "text": "Палец ставим кончиком, вплотную к металлическому порожку (не на него и не в середину лада). Большой палец — сзади грифа, примерно напротив среднего. Пробуем 1-ю струну на 1, 3 и 5 ладу."
                },
                {
                    "name": "Упражнение «паучок»",
                    "min": 10,
                    "text": "Играем медленно на 6-й и 5-й струне, каждый палец на свой лад. 5 проходов туда-обратно."
                },
                {
                    "name": "Мелодия",
                    "min": 3,
                    "text": "Мелодия по одной струне: 0-1-3-5-3-1-0 на 1-й струне."
                }
            ],
            "new": "Постановка левой руки, упражнение «паучок»",
            "check": "Ни одна нота не дребезжит",
            "parent": "Дребезг — это почти всегда «палец далеко от порожка» или «недожал». Не ругаем, просто передвигаем палец ближе к порожку.",
            "fun": "Соревнование: кто сыграет «паучка» медленнее и ровнее (именно медленнее!)."
        },
        {
            "day": 4,
            "week": 1,
            "type": "lesson",
            "title": "Первая настоящая мелодия",
            "goal": "Сыграть узнаваемую мелодию по табулатуре",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + «паучок» 3 прохода."
                },
                {
                    "name": "Как читать табы",
                    "min": 3,
                    "text": "6 линеек — 6 струн, верхняя линейка — самая тонкая струна. Цифра — номер лада, 0 — открытая струна. Читаем слева направо."
                },
                {
                    "name": "Ода к радости",
                    "min": 10,
                    "text": "Табулатура «Ода к радости» (см. раздел табулатур). Учим по 4 ноты, потом соединяем. Играем очень медленно."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Играем мелодию целиком 2 раза."
                }
            ],
            "new": "Чтение табулатуры, первая мелодия",
            "check": "Мелодия узнаётся на слух",
            "parent": "Если получается — попросите сыграть вам «концерт» на 30 секунд. Публика важна.",
            "fun": "Найти на YouTube оригинал «Оды к радости» и подыграть последние ноты."
        },
        {
            "day": 5,
            "week": 1,
            "type": "lesson",
            "title": "Итоги первой недели",
            "goal": "Закрепить всё, что было, и показать результат",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 5,
                    "text": "Настройка, «паучок» на всех струнах."
                },
                {
                    "name": "Повтор",
                    "min": 7,
                    "text": "Перебор «четвёрка» 10 раз + мелодия «Ода к радости» 3 раза."
                },
                {
                    "name": "Мини-концерт",
                    "min": 5,
                    "text": "Играем всё выученное подряд, как программу выступления, для родителей или для камеры."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Свободная игра: играем что хочется."
                }
            ],
            "new": "Ничего нового — только закрепление",
            "check": "Мелодия и перебор играются без подсказок",
            "parent": "Похвалите за конкретику: «чисто звучит 3-я струна», «ровный ритм» — это работает лучше общего «молодец».",
            "fun": "Видео недели №1. Сравним с днём 1."
        },
        {
            "day": 6,
            "week": 1,
            "type": "rest",
            "title": "Выходной",
            "text": "Занятия нет. Можно просто взять гитару в руки и побренчать что угодно — без правил. Или послушать 2–3 песни и подумать, какую хочется научиться играть."
        },
        {
            "day": 7,
            "week": 1,
            "type": "rest",
            "title": "Выходной",
            "text": "Отдыхаем. Задание на минуту: выбрать песню-мечту месяца и сказать её вслух родителям. К концу курса сыграем что-то похожее."
        },
        {
            "day": 8,
            "week": 2,
            "type": "lesson",
            "title": "Первый аккорд: Em",
            "goal": "Поставить Em так, чтобы звучали все 6 струн",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + «паучок»."
                },
                {
                    "name": "Ставим Em",
                    "min": 8,
                    "text": "Диаграмма Em: 2-й палец на 5-ю струну 2-й лад, 3-й палец на 4-ю струну 2-й лад. Играем струны по одной сверху вниз и слушаем каждую: все 6 должны звучать чисто."
                },
                {
                    "name": "Убрать-поставить",
                    "min": 5,
                    "text": "Ставим Em, играем, полностью убираем руку, ставим заново. 15 раз. Цель — чтобы рука запомнила форму."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Играем перебором «четвёрка» на Em 8 раз подряд."
                }
            ],
            "new": "Аккорд Em",
            "check": "Все 6 струн в Em звучат чисто",
            "parent": "Проверка простая: попросите сыграть струны по одной. Глухая струна = палец задевает соседнюю.",
            "fun": "Em звучит грустно и «по-взрослому» — под него уже можно что-то напевать."
        },
        {
            "day": 9,
            "week": 2,
            "type": "lesson",
            "title": "Второй аккорд: Am",
            "goal": "Поставить Am и начать менять его с Em",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + Em 10 раз (поставить-убрать)."
                },
                {
                    "name": "Ставим Am",
                    "min": 7,
                    "text": "Смотрим схему аккорда Am в тренажёре «Аккорды». Это тот же Em, сдвинутый на струну вниз, плюс 1-й палец на 2-ю струну 1-й лад. 6-ю струну не играем."
                },
                {
                    "name": "Смена Em → Am",
                    "min": 6,
                    "text": "Медленно: играем Em на счёт 1-2-3-4, на «4» готовим руку, на следующий «раз» — Am. Пауза разрешена: скорость придёт сама."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Перебор на Em и Am по очереди."
                }
            ],
            "new": "Аккорд Am, первая смена аккордов",
            "check": "Смена Em↔Am за 3 секунды",
            "parent": "Смена аккордов — самое трудное место у всех новичков. Тут нужно просто время, а не талант.",
            "fun": "Em и Am вместе уже звучат как настоящая песня."
        },
        {
            "day": 10,
            "week": 2,
            "type": "lesson",
            "title": "Бой «вниз»",
            "goal": "Играть ровный ритм ударами вниз",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + Em/Am."
                },
                {
                    "name": "Правая рука",
                    "min": 6,
                    "text": "Берём медиатор (или играем подушечкой большого пальца). Удар вниз на каждый счёт: 1, 2, 3, 4. Двигается кисть, а не вся рука. Играем на Em, 20 тактов."
                },
                {
                    "name": "Смена под ритм",
                    "min": 7,
                    "text": "4 удара на Em, 4 удара на Am, по кругу. Темп медленный — главное не останавливаться."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Играем то же самое, считая вслух."
                }
            ],
            "new": "Бой «вниз», медиатор",
            "check": "8 кругов Em/Am без остановки",
            "parent": "Метроном можно включить прямо в тюнер-приложении: 60–70 ударов в минуту.",
            "fun": "Попробовать играть под барабанный трек с YouTube («drum beat 70 bpm»)."
        },
        {
            "day": 11,
            "week": 2,
            "type": "lesson",
            "title": "Третий аккорд: Dm",
            "goal": "Добавить Dm и связку из трёх аккордов",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + Em/Am боем."
                },
                {
                    "name": "Ставим Dm",
                    "min": 7,
                    "text": "Смотрим схему аккорда Dm в тренажёре «Аккорды». Играем только 4 тонкие струны. Пальцы образуют горку."
                },
                {
                    "name": "Связка",
                    "min": 6,
                    "text": "Am — Dm — Em — Am, по 4 удара на аккорд, очень медленно."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Та же связка перебором."
                }
            ],
            "new": "Аккорд Dm, связка из трёх аккордов",
            "check": "Круг Am–Dm–Em проходится без длинных пауз",
            "parent": "Если Dm не даётся — оставьте его и вернитесь завтра, это нормальный аккорд-трудность.",
            "fun": "Эта связка звучит «испански» — можно играть быстро и драматично."
        },
        {
            "day": 12,
            "week": 2,
            "type": "lesson",
            "title": "Итоги второй недели",
            "goal": "Собрать три аккорда в законченный кусок",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + «паучок»."
                },
                {
                    "name": "Игра на скорость",
                    "min": 5,
                    "text": "Минута на смену Em↔Am: считаем, сколько раз успели поменять. Записываем рекорд — будем бить его на 4-й неделе."
                },
                {
                    "name": "Программа",
                    "min": 8,
                    "text": "8 тактов: Em (4 удара) — Am (4) — Dm (4) — Em (4), два круга, боем «вниз» под счёт."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Мини-концерт + видео недели №2."
                }
            ],
            "new": "Закрепление",
            "check": "Рекорд смены аккордов записан, программа сыграна целиком",
            "parent": "Записывайте рекорд в блокнот или в бота — измеримый прогресс сильно мотивирует.",
            "fun": "Сравнить видео недели 1 и 2."
        },
        {
            "day": 13,
            "week": 2,
            "type": "rest",
            "title": "Выходной",
            "text": "Отдыхаем. Пальцы левой руки за это время немного огрубеют — так и должно быть."
        },
        {
            "day": 14,
            "week": 2,
            "type": "rest",
            "title": "Выходной",
            "text": "Задание на 5 минут: найти в интернете аккорды к песне-мечте и посмотреть, какие аккорды там нужны. Скорее всего, часть уже знакома."
        },
        {
            "day": 15,
            "week": 3,
            "type": "lesson",
            "title": "Аккорд C",
            "goal": "Освоить C и связку Am–C",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + Em/Am/Dm боем."
                },
                {
                    "name": "Ставим C",
                    "min": 7,
                    "text": "Смотрим схему аккорда C в тренажёре «Аккорды». Если полный вариант тяжёл — играем упрощённый: только 3 тонкие струны (1-я открытая, 2-я на 1 ладу, 3-я открытая)."
                },
                {
                    "name": "Am → C",
                    "min": 6,
                    "text": "Секрет: 1-й палец в Am и в C стоит на одном и том же месте (2-я струна, 1-й лад). Он не двигается — переставляем только два других пальца. 20 смен."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Am–C перебором."
                }
            ],
            "new": "Аккорд C, приём «общий палец»",
            "check": "Смена Am↔C за 2 секунды",
            "parent": "«Общий палец» — главный секрет быстрой смены аккордов. Ищите его в каждой новой паре.",
            "fun": "Am–C — начало десятков популярных песен."
        },
        {
            "day": 16,
            "week": 3,
            "type": "lesson",
            "title": "Аккорд G",
            "goal": "Освоить G, соединить с C",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + Am/C."
                },
                {
                    "name": "Ставим G",
                    "min": 7,
                    "text": "Смотрим схему аккорда G в тренажёре «Аккорды». Облегчённый вариант на первые дни: только 6-я струна на 3 ладу и 1-я струна на 3 ладу, остальные открытые."
                },
                {
                    "name": "C → G",
                    "min": 6,
                    "text": "По 4 удара на аккорд. Медленно, с паузой на перестановку — пауза со временем исчезнет."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "G–C–G–C боем «вниз»."
                }
            ],
            "new": "Аккорд G",
            "check": "G звучит без глухих струн",
            "parent": "Облегчённый G — не читерство, а нормальный рабочий вариант, его используют и взрослые.",
            "fun": "G — самый «светлый» аккорд, с него начинается много весёлых песен."
        },
        {
            "day": 17,
            "week": 3,
            "type": "lesson",
            "title": "Аккорд D и «четыре аккорда»",
            "goal": "Собрать связку G–D–Em–C",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + G/C."
                },
                {
                    "name": "Ставим D",
                    "min": 6,
                    "text": "Смотрим схему аккорда D в тренажёре «Аккорды». Если тяжело — играем Dsus2 (на один палец меньше), звучит почти так же."
                },
                {
                    "name": "Волшебная связка",
                    "min": 7,
                    "text": "G — D — Em — C, по 4 удара. На этой последовательности построены сотни поп-песен: сыграв её, ребёнок фактически играет припев множества хитов."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Два круга связки без остановок."
                }
            ],
            "new": "Аккорд D, поп-последовательность из 4 аккордов",
            "check": "Круг G–D–Em–C проходится 4 раза подряд",
            "parent": "Покажите ролики «four chords song» — там наглядно, сколько известных песен на этих аккордах. Это сильный вау-эффект.",
            "fun": "Попробовать напеть под связку любую знакомую песню — часто просто попадает."
        },
        {
            "day": 18,
            "week": 3,
            "type": "lesson",
            "title": "Бой «восьмёрка»",
            "goal": "Освоить главный универсальный бой",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + связка G–D–Em–C."
                },
                {
                    "name": "Качаем руку",
                    "min": 6,
                    "text": "Рука качается вверх-вниз непрерывно, как маятник, считаем «раз-и-два-и-три-и-четыре-и». Сначала без струн, в воздухе."
                },
                {
                    "name": "Схема",
                    "min": 7,
                    "text": "Бой: ровные восьмые вниз-вверх — ↓↑↓↑↓↑↓↑. Играем на одном аккорде Em, пока рука не начнёт качаться сама."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Тот же бой на Am и C."
                }
            ],
            "new": "Бой «восьмёрка»",
            "check": "Бой играется 1 минуту без сбоев на одном аккорде",
            "parent": "Главная ошибка — останавливать руку. Рука качается всегда, просто иногда мимо струн.",
            "fun": "Под этот бой играется большинство песен у костра."
        },
        {
            "day": 19,
            "week": 3,
            "type": "lesson",
            "title": "Первая песня",
            "goal": "Сыграть настоящую песню целиком",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + бой «восьмёрка» на Em."
                },
                {
                    "name": "Выбор песни",
                    "min": 3,
                    "text": "Выбираем песню, где нужны только знакомые аккорды: Am–C–D–Em или G–D–Em–C. Аккорды ищем на любом сайте с подборами по названию песни."
                },
                {
                    "name": "Разбор",
                    "min": 10,
                    "text": "Играем только первый куплет. Сначала боем «вниз», потом «восьмёркой». Медленно — темп ставим такой, чтобы ни разу не сбиться."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Играем куплет 2 раза подряд."
                }
            ],
            "new": "Работа с подбором аккордов, первая песня",
            "check": "Куплет проигран без остановок в медленном темпе",
            "parent": "Песню выбирает ребёнок, даже если она вам не нравится — мотивация тут важнее вкуса.",
            "fun": "Спеть вместе, даже если фальшиво. Особенно если фальшиво."
        },
        {
            "day": 20,
            "week": 3,
            "type": "rest",
            "title": "Выходной",
            "text": "Отдыхаем. Можно показать друзьям, что уже умеешь — это тоже часть обучения."
        },
        {
            "day": 21,
            "week": 3,
            "type": "rest",
            "title": "Выходной",
            "text": "Задание на 5 минут: найти табулатуру мелодии из любимой игры, аниме или фильма — на следующей неделе будем её учить."
        },
        {
            "day": 22,
            "week": 4,
            "type": "lesson",
            "title": "Скорость смены аккордов",
            "goal": "Убрать паузы между аккордами",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + бой «восьмёрка»."
                },
                {
                    "name": "Игра «60 секунд»",
                    "min": 8,
                    "text": "Минута на каждую пару: Am↔C, C↔G, G↔D, Em↔Am. Считаем количество чистых смен, записываем. Сравниваем с рекордом дня 12."
                },
                {
                    "name": "Медленно и чисто",
                    "min": 5,
                    "text": "Проходим связку G–D–Em–C так медленно, чтобы паузы не было вообще."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Играем куплет своей песни."
                }
            ],
            "new": "Тренировка скорости как отдельное упражнение",
            "check": "Рекорд побит хотя бы в одной паре",
            "parent": "Рекорды хорошо вести списком — прогресс за неделю обычно 1.5–2 раза, и это очень заметно.",
            "fun": "Устроить соревнование с родителем, который не умеет играть — заведомая победа."
        },
        {
            "day": 23,
            "week": 4,
            "type": "lesson",
            "title": "Рок-рифф",
            "goal": "Сыграть риффом на басовых струнах",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + «паучок» медиатором."
                },
                {
                    "name": "Рифф",
                    "min": 10,
                    "text": "Рок-рифф (см. раздел табулатур): играем на 6-й струне медиатором, только удары вниз, ровно. Сначала очень медленно, потом ускоряем."
                },
                {
                    "name": "Приглушение",
                    "min": 3,
                    "text": "Кладём ребро правой ладони на струны у подставки — звук становится глухим и «злым». Это приём палм-мьют, он и делает звук роковым."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Играем рифф с приглушением 4 раза."
                }
            ],
            "new": "Игра медиатором по басам, приглушение (palm mute)",
            "check": "Рифф играется ровно в среднем темпе",
            "parent": "Этот день обычно самый «вкусный» — тут гитара впервые звучит как в любимой музыке.",
            "fun": "Придумать свой рифф из 4 нот на 6-й струне и дать ему название."
        },
        {
            "day": 24,
            "week": 4,
            "type": "lesson",
            "title": "Мелодия из игры или фильма",
            "goal": "Выучить первую фразу любимой мелодии по табу",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + рифф вчерашнего дня."
                },
                {
                    "name": "Разбор",
                    "min": 12,
                    "text": "Берём найденную табулатуру (Minecraft, Zelda, «Гарри Поттер», аниме — что выбрал ребёнок). Учим только первые 8 нот. Разбиваем на кусочки по 2–3 ноты."
                },
                {
                    "name": "Финал",
                    "min": 4,
                    "text": "Играем фразу 5 раз подряд, каждый раз чуть быстрее."
                }
            ],
            "new": "Самостоятельная работа с табами",
            "check": "8 нот мелодии играются подряд и узнаются",
            "parent": "Если таб оказался сложным (баррэ, много ладов) — ищите версию с пометкой «easy» или «для начинающих».",
            "fun": "Сыграть фразу и попросить угадать, что это."
        },
        {
            "day": 25,
            "week": 4,
            "type": "lesson",
            "title": "Играем под оригинал",
            "goal": "Попасть в темп настоящей записи",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + связка G–D–Em–C боем."
                },
                {
                    "name": "Замедляем",
                    "min": 6,
                    "text": "Включаем оригинал песни на YouTube и ставим скорость 0.75. Играем аккорды вместе с записью."
                },
                {
                    "name": "Полный темп",
                    "min": 7,
                    "text": "Пробуем на скорости 1.0. Сбиваться — нормально: задача попадать хотя бы в первую долю каждого такта."
                },
                {
                    "name": "Финал",
                    "min": 3,
                    "text": "Играем куплет самостоятельно, без записи."
                }
            ],
            "new": "Игра под фонограмму, работа со скоростью",
            "check": "Куплет сыгран вместе с записью на скорости 0.75",
            "parent": "Умение играть с записью — это уже музицирование, а не упражнения. Хороший момент похвалить.",
            "fun": "Записать видео, где играешь под оригинал."
        },
        {
            "day": 26,
            "week": 4,
            "type": "lesson",
            "title": "Репетиция концерта",
            "goal": "Собрать программу выступления",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Разминка",
                    "min": 4,
                    "text": "Настройка + всё, что разминает пальцы."
                },
                {
                    "name": "Программа",
                    "min": 12,
                    "text": "Три номера: 1) мелодия (Ода к радости или из игры), 2) рифф, 3) песня с аккордами. Проходим каждый номер один раз подряд, не останавливаясь на ошибках — как на настоящем концерте."
                },
                {
                    "name": "Финал",
                    "min": 4,
                    "text": "Прогоняем программу целиком второй раз."
                }
            ],
            "new": "Игра целиком без остановок",
            "check": "Программа из 3 номеров проходится подряд",
            "parent": "Главное правило репетиции: ошибся — играешь дальше. Останавливаться нельзя.",
            "fun": "Придумать название своему концерту и объявить время."
        },
        {
            "day": 27,
            "week": 4,
            "type": "rest",
            "title": "Выходной",
            "text": "Отдыхаем перед концертом. Можно поиграть что хочется, без задания."
        },
        {
            "day": 28,
            "week": 4,
            "type": "rest",
            "title": "Выходной",
            "text": "Лёгкий прогон программы 5 минут — и всё. Завтра выступление."
        },
        {
            "day": 29,
            "week": 5,
            "type": "concert",
            "title": "Домашний концерт",
            "goal": "Выступить перед публикой и записать видео",
            "duration_min": 20,
            "blocks": [
                {
                    "name": "Настройка",
                    "min": 3,
                    "text": "Настраиваем гитару, разминаем пальцы."
                },
                {
                    "name": "Концерт",
                    "min": 12,
                    "text": "Три номера подряд перед семьёй. Объявляем каждый номер вслух. Снимаем на видео."
                },
                {
                    "name": "Просмотр",
                    "min": 5,
                    "text": "Смотрим видео дня 1 и видео сегодня. Разница за месяц обычно поражает."
                }
            ],
            "new": "Опыт выступления",
            "check": "Концерт состоялся, видео записано",
            "parent": "Аплодисменты обязательны. Критику — не сегодня.",
            "fun": "Отправить видео бабушке или другу."
        },
        {
            "day": 30,
            "week": 5,
            "type": "review",
            "title": "Итоги месяца и что дальше",
            "goal": "Зафиксировать результат и выбрать направление",
            "duration_min": 15,
            "blocks": [
                {
                    "name": "Что умеем",
                    "min": 5,
                    "text": "Чек-лист: 6 аккордов (Em, Am, Dm, C, G, D), два боя, перебор, чтение табов, 2–3 мелодии, 1 песня целиком, рифф с приглушением."
                },
                {
                    "name": "Куда дальше",
                    "min": 5,
                    "text": "Три направления на выбор: 1) песни — учить по 1 новой песне в неделю; 2) мелодии и соло — фингерстайл, табы из игр и фильмов; 3) техника — баррэ (F), новые бои, ритмика. Обычно берут одно основное и одно второстепенное."
                },
                {
                    "name": "План на месяц 2",
                    "min": 5,
                    "text": "Договориться о новом режиме: те же 15–20 минут 5 раз в неделю. Если интерес крепкий — самое время подумать о преподавателе раз в неделю: он снимет технические ошибки, которые сам не увидишь."
                }
            ],
            "new": "Рефлексия и постановка целей",
            "check": "Направление на следующий месяц выбрано ребёнком",
            "parent": "Второй месяц — самый рискованный: новизна прошла, а прогресс замедляется. Спасает репертуар: играть то, что нравится, а не только упражнения.",
            "fun": "Составить список из 5 песен-целей на следующий месяц."
        }
    ]
};
//# sourceMappingURL=course.data.js.map